import { useMemo } from "react";

import { EntityHelper } from "@/common/helpers/entity";
import { BaseEntityDtoAny, EntityFormMeta } from "@/common/ts/entity";

interface Props {
  entity: Nil<BaseEntityDtoAny>;
}

export function useEntityFormMeta({ entity }: Props): EntityFormMeta | null {
  const meta = useMemo(() => EntityHelper.getEntityFormMetaOrNull(entity), [entity]);
  return meta;
}
